import {observer} from "mobx-react-lite";
import Box from "@mui/material/Box";
import {Avatar, CircularProgress, Typography} from "@mui/material";
import React, {lazy, Suspense, useEffect, useState} from "react";
import {CommentGroupProps} from "../../../../entity/props/comment/comment-group-props";
import {Comments} from "../../../../entity/resource/comments";
import {useService} from "../../../../infrastructure/service/service";
import {Title} from "../../../../entity/model/title";

import '../../../../assets/css/comment/comment-group.css';

const CommentGroup = (props: CommentGroupProps): JSX.Element => {
    const {titleService} = useService();
    const [title, setTitle] = useState<Title>();

    useEffect(() => {
        setTitle(titleService.getTitle());
    }, [titleService.getTitle()]);

    const LazyFullNameComponent = lazy(() => import('../widget/FullNameComponent'));

    const getAuthorDescription = (userId: string): string => {
        if (userId === props.currentUser?.id)
            return 'You';

        if (title && title.assignedToUserID === userId)
            return 'Abstractor';

        if (title && title.assignedToReviewerUserID === userId)
            return 'Reviewer';

        if (title && title.assignedToApproverUserID === userId)
            return 'Approver';

        if (title && title.createdByUserID === userId)
            return 'Owner';

        return 'User';
    }

    return (
        <Box className={'comment-group-container'}>
            {
                title && title.comments.length > 0
                    ? title.comments
                        .slice()
                        .sort((a: Comments, b: Comments) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime())
                        .map((comment: Comments, index: number): JSX.Element => (
                            <Box key={index} id={`comment-item-${index}`} overflow={'auto'} flexGrow={1} paddingTop={2} paddingLeft={2} paddingRight={2}>
                                <Box mb={1} display={'flex'} gap={1}>
                                    <Avatar id={`avatar-comment-${index}`} alt='Author Avatar' src="https://via.placeholder.com/40" />
                                    <Box>
                                        <Typography id={`text-comment-author-${index}`} className={'comment-author'}>
                                            <Suspense fallback={<CircularProgress size={16} />}>
                                                <LazyFullNameComponent commentCreatedUser={comment.createdByUserID} />
                                            </Suspense>
                                            <span id={`text-comment-date-${index}`} className={'comment-date'}>{new Date(comment.createdAt).toLocaleString()}</span>
                                        </Typography>
                                        <Typography id={`text-comment-description-${index}`} className={'comment-author description'}>{ getAuthorDescription(comment.createdByUserID) }</Typography>
                                        <Typography id={`text-comment-message-${index}`} className='comment-message'>{comment.comment}</Typography>
                                    </Box>
                                </Box>
                            </Box>
                    ))
                    : <Typography id={'text-no-comments'} className={'comment-message empty'}>No comments</Typography>
            }
        </Box>
    );
}

export default observer(CommentGroup);
